import { type DefaultRole } from '../types'
import { type RoleId } from '../../role'

export const DEFAULT_TEAM_MANAGER_ID: RoleId = 'Role.manager'

export const DEFAULT_TEAM_MANAGER: DefaultRole = {
  roleId: DEFAULT_TEAM_MANAGER_ID,
  name: 'Manager',
  permissionOverrides: [
    { permissionType: 'account:list', scope: 'downline' }, // view accounts for my downline
    { permissionType: 'area:add', scope: 'downline' }, // add areas for teams and users in my downline
    { permissionType: 'area:list', scope: 'downline' }, // list areas for teams and users in my downline
    { permissionType: 'attachment:manage', scope: 'downline' }, // manage attachments for my downline
    { permissionType: 'availability:manage', scope: 'downline' },
    { permissionType: 'contact:list', scope: 'downline' }, // list contacts for my downline
    { permissionType: 'conversation:list', scope: 'downline' }, // list conversations for any user in my downline
    { permissionType: 'conversation:manage', scope: 'downline' }, // manage conversations for any user in my downline
    { permissionType: 'disposition:save', scope: 'downline' }, // save dispositions for my team and downline users
    { permissionType: 'evaluation:add', scope: 'downline' }, // able to record evaluation for any user in my downline
    { permissionType: 'evaluation:delete', scope: 'downline' }, // delete evaluation for my downline
    { permissionType: 'evaluation:list', scope: 'downline' }, // get evaluation for my downline
    { permissionType: 'event:read', scope: 'downline' }, // list events for any user in my downline
    { permissionType: 'event:manage', scope: 'downline' }, // manage events for any user in my downline
    { permissionType: 'event:save', scope: 'downline' }, // save events for any user in my downline
    { permissionType: 'event:delete', scope: 'downline' }, // delete events for my downline
    { permissionType: 'availability:list', scope: 'downline' }, // list closer availability for any user in my downline
    { permissionType: 'message:send', scope: 'downline' }, // send messages to my downline
    { permissionType: 'message:send:group', scope: 'downline' }, // send messages to groups in my downline
    { permissionType: 'plan:list', scope: 'downline' }, // list plans for team and downline
    { permissionType: 'plan:add', scope: 'downline' }, // add plans for team and downline
    { permissionType: 'plan:manage', scope: 'downline' }, // manage and approve plans for team and downline
    { permissionType: 'program:manage', scope: 'downline' }, // manage programs for my downline
    { permissionType: 'rubric:manage', scope: 'downline' }, // manage rubrics for my downline
    { permissionType: 'team:add', scope: 'downline' }, // add sub teams for my downline
    { permissionType: 'team:update', scope: 'downline' }, // update my own team or downline
    { permissionType: 'team:list', scope: 'downline' }, // list teams for my downline
    { permissionType: 'task:list', scope: 'downline' }, // list tasks for my downline
    { permissionType: 'task:update', scope: 'downline' }, // update or archive tasks for any user in my downline
    { permissionType: 'user:add', scope: 'downline' }, // add users for my downline
    { permissionType: 'user:manage', scope: 'downline' }, // update users in my downline
    { permissionType: 'user:update', scope: 'downline' }, // update users in my downline
    { permissionType: 'game:save', scope: 'downline' }, // save games for my downline
    { permissionType: 'game:list', scope: 'downline' }, // save games for my downline
    { permissionType: 'externalLink:manage', scope: 'downline' }, // manage external links for my downline
    { permissionType: 'view:manage', scope: 'downline' }, // share saved views with my downline
    { permissionType: 'widget:manage', scope: 'downline' }, // manage widgets for my downline
    { permissionType: 'workflow:list', scope: 'company' }, // list workflows for my company
    { permissionType: 'reportConfig:manage', scope: 'downline' },
    { permissionType: 'dashboard:list', scope: 'company' },
    { permissionType: 'dashboard:manage', scope: 'downline' },
  ],
}
